import { headerLogoEndAlt } from './HeaderLogoStore.js';

export const updateHeaderLogoEndAlt = (value) => headerLogoEndAlt.update((oldValue) => value);
